import type { UpdateWorkfrontConfig } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { WorkfrontConfigDto } from './use-workfront-configs.js';

interface UpdateWorkfrontConfigInput {
  clientId: string;
  configId: string;
  patch: UpdateWorkfrontConfig;
}

/** Mutation for `PUT /v1/clients/{clientId}/workfront-configs/{configId}`. */
export function useUpdateWorkfrontConfigMutation(): UseMutationResult<
  WorkfrontConfigDto,
  Error,
  UpdateWorkfrontConfigInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, configId, patch }: UpdateWorkfrontConfigInput) => {
      if (!api) throw new Error('useUpdateWorkfrontConfigMutation: api client unavailable');
      return api.put<WorkfrontConfigDto>(
        `/v1/clients/${clientId}/workfront-configs/${configId}`,
        patch,
      );
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['workfront-configs', clientId] });
    },
  });
}
